/**
 * Paginates the given array by slicing it into pages of the given page size.
 * @param array - The array to paginate
 * @param pageSize - The number of items per page
 * @param pageNumber - The page number to retrieve
 * @returns The slice of the array for the given page
 */
export const paginate = (
  array: Array<any>,
  pageSize: number,
  pageNumber: number
) => {
  return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
};
